import { v4 as uuidv4 } from 'uuid';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { FilterNavigatorV3 } from '../../../../vtex-apps/search-result/FilterNavigatorV3/default';
import { Gallery } from '../../../../vtex-apps/search-result/Gallery/default';
import { OrderByV2 } from '../../../../vtex-apps/search-result/OrderByV2/default';
import { SearchContent } from '../../../../vtex-apps/search-result/SearchContent/default';
import { SearchFetchMore } from '../../../../vtex-apps/search-result/SearchFetchMore/default';
import { SearchFetchPrevious } from '../../../../vtex-apps/search-result/SearchFetchPrevious/default';
import { SearchTitleV2 } from '../../../../vtex-apps/search-result/SearchTitleV2/default';
import { TotalProductsV2 } from '../../../../vtex-apps/search-result/TotalProductsV2/default';

//this one is slightly different, this will be called from the default.js of the component
//and the component renderer will call that default.js
export default function SearchResult() {
	return {
		componentName: 'SearchResultLayoutDesktop',
		componentId: uuidv4(),
		componentGroup: 'SearchResultLayoutDesktop',
		props: {
			blockClass: 'srl__desktop-1',
			title: 'MZ | Resultado de Busca Desktop',
		},
		variables,
		childrenComponents: [
			{
				componentGroup: 'BreadcrumbGroup',
				componentName: 'FlexLayoutRow',
				componentId: uuidv4(),
			},
			FlexLayoutRow(
				{
					blockClass: 'searchContent',
					colGap: { desktop: 2, tablet: 2, phone: 0 },
					colSizing: 'auto',
				},
				[
					FlexLayoutCol(
						{
							blockClass: 'col__filters',
							preventVerticalStretch: true,
							width: { desktop: '22%', mobile: '22%' },
						},
						[SearchTitleV2(), FilterNavigatorV3()],
					),
					FlexLayoutCol(
						{
							blockClass: 'col__content',
							preventVerticalStretch: true,
							width: { desktop: '78%', mobile: '78%' },
						},
						[
							SearchFetchPrevious(),
							FlexLayoutRow(
								{
									blockClass: 'total-orderby',
								},
								[
									FlexLayoutCol(
										{
											blockClass: 'col__quantity',
											preventVerticalStretch: true,
											width: '100%',
										},
										[TotalProductsV2()],
									),
									FlexLayoutCol(
										{
											blockClass: 'col__order',
											preventVerticalStretch: true,
											width: '100%',
										},
										[OrderByV2()],
									),
								],
							),
							FlexLayoutRow(
								{
									blockClass: 'row__result',
									colSizing: 'equal',
									fullWidth: false,
									colGap: { desktop: 2, tablet: 2, phone: 0 },
								},
								[
									SearchContent(
										{},
										[],
										[
											Gallery({
												layouts: [
													{
														name: 'grid',
														component: 'GridSummary',
														itemsPerRow: {
															desktop: 3,
															tablet: 3,
															phone: 2,
														},
													},
												],
												GridSummary: {
													componentGroup: 'ProductSummaryShelf',
													componentName: 'ProductSummaryShelfComponent',
													componentId: uuidv4(),
												},
											}),
										],
									),
								],
							),
							SearchFetchMore(),
						],
					),
				],
			),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--text-color-1', to: '--srld-1-title-color', name: 'Cor do título' },
			{
				from: '--text-color-1',
				to: '--srld-1-title-qtd-color',
				name: 'Cor da qtd de produtos/ordenar',
			},
			{
				from: '--brand-color-primary-pure',
				to: '--srld-1-filter-title-color',
				name: "Cor do título 'Filtros'",
			},
			{
				from: '--text-color-1',
				to: '--srld-1-options-title-color',
				name: 'Cor dos títulos das opções',
			},
			{
				from: '--text-color-1',
				to: '--srld-1-options-text-color',
				name: 'Cor dos textos das opções',
			},
			{
				from: '--brand-color-primary-pure',
				to: '--srld-1-checkpoint-bg',
				name: 'Cor de background do checkpoint',
			},
			{
				from: '--white',
				to: '--srld-1-checkpoint',
				name: 'Cor da marcação checkpoint',
			},
			{
				from: '--brand-color-primary-pure',
				to: '--srld-1-arrow-color',
				name: 'Cor da arrow do filtro lateral',
			},
			//mostrar mais colors
			{ from: '--white', to: '--srld-1-show-more-color', name: 'Mostrar mais' },
			{ from: '--cta-color-pure', to: '--srld-1-show-more-bg-color', name: 'Mostrar mais Bg' },
			{ from: '--cta-color-hover', to: '--srld-1-show-more-bg-hover', name: 'Mostrar mais Hover' },
			{ from: '--cta-color-focus', to: '--srld-1-show-more-bg-active', name: 'Mostrar mais Active' },
			//-srld-1-checkbox-border
			{ from: '--neutral-color-low-light', to: '--srld-1-checkbox-border', name: 'Checkbox border' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xxxl', to: '--srld-1-title-size', name: 'Tamanho do título' },
			{ from: '--font-size-sm', to: '--srld-1-title-qtd-size', name: 'Tamanho da qtd de produtos/ordenar' },
			{ from: '--font-size-lg', to: '--srld-1-filter-title-size', name: "Tamanho do título 'Filtros'" },
			{ from: '--font-size-xs', to: '--srld-1-options-title-size', name: 'Tamanho dos títulos das opções' },
			{ from: '--font-size-xxs', to: '--srld-1-options-text-size', name: 'Tamanho dos textos das opções' },
			{ from: '--font-size-xs', to: '--srld-1-show-more-fs', name: 'Mostrar Mais' },
			//--srld-1-check-icon-size
			{ from: '--font-size-xs', to: '--srld-1-check-icon-size', name: 'Tamanho do ícone de check' },
		],
	},
	{
		type: 'borderRadius',
		list: [
			//mostrar mais borderRadius
			{ from: '--border-radius-none', to: '--srld-1-show-more-btn-br', name: 'Mostrar Mais' },
			//--srld-1-dd-border-radius
			{ from: '--border-radius-none', to: '--srld-1-dd-border-radius', name: 'Border Radius Dropdown' },
			//--srld-1-checkbox-br
			{ from: '--border-radius-none', to: '--srld-1-checkbox-br', name: 'Border Radius Checkbox' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			//mostrar mais fontWeight
			{ from: '--font-weight-400', to: '--srld-1-show-more-fw', name: 'Mostrar Mais' },
			//peso titulo galeria
			{ from: '--font-weight-400', to: '--srld-1-title-fw', name: 'Peso do título' },
		],
	},
	//spacing
	{
		type: 'spacing',
		list: [
			//--srld-1-checkbox-size
			{ from: '--spacing-xxxs', to: '--srld-1-checkbox-size', name: 'Tamanho do checkbox' },
		],
	},
];
